(ns teamoesterreich.user-mode.landing.events.event-list
  (:require [clojure.string]
            [goog.date.DateTime]
            [reagent-material-ui.components :as mui]
            [reagent-material-ui.icons.account-box :refer [account-box]]
            [reagent-material-ui.icons.check-circle-outline :refer [check-circle-outline]]

            [reagent-material-ui.icons.filter-1 :refer [filter-1]]
            [reagent-material-ui.icons.inbox :refer [inbox]]
            [reagent-material-ui.icons.info :refer [info]]
            [reagent-material-ui.icons.location-off :refer [location-off]]
            [reagent-material-ui.icons.location-searching :refer [location-searching]]
            [reagent-material-ui.icons.notifications :refer [notifications]]
            [reagent-material-ui.icons.phone-android :refer [phone-android]]
            [reagent.core :as r]
            [teamoesterreich.store :as store]
            [teamoesterreich.user-mode.actions :as a]
            [teamoesterreich.user-mode.syncer :as syncer]

            ))


(defn event-card [d-event]
  (let [!select-event (r/cursor store/app-state [:select-event])

        ]
    [mui/card {:style {:border-radius "15px" :margin "5px" :padding "3px" :backgroundColor (cond
                                                                                             (:_allowed d-event) "white"
                                                                                             (:_accepted d-event) "white"
                                                                                             (:_rejected d-event) "#e4e4e4"
                                                                                             :else "#c4c4c4")}}
     [mui/card-header
      {:title (r/as-element [mui/grid {:container true}
                             [mui/grid {:item true :md 8 :xs 12 :style {:textAlign "left"}}
                              [:span {:style {:fontSize "16px" :fontWeight "bold"}}
                               (:crowdtaskerEvent-name d-event)
                               (when (false? (:crowdtaskerEvent-published d-event)) " - NICHT VERÖFFENTLICHT")]
                              [:br]
                              [:span {:style {:fontSize "14px"}} (:_locationName d-event)]
                              (when (< (:_freePlaces d-event) 10000) [:span {:style {:fontSize "14px" :float "right"}} (str "Es werden noch " (:_freePlaces d-event) " Personen benötigt!")])
                              [:br]
                              [:span {:style {:fontSize "14px"}} (:_crowdtaskerEvent-timeFrom d-event)]]
                             (cond
                               false
                               [mui/grid {:item  true :md 4 :xs 12
                                          :style {:textAlign "center"}}
                                [mui/chip {:icon  (r/as-element [account-box]) ;nicht mehr nötig, sobald Fragebögen in der Webapp möglich sind...
                                           :style {:backgroundColor "#ff7f7f" :margin "3px"}
                                           :label (str "Bitte melde dich an!")
                                           }]
                                ]

                               (:_rejected d-event)
                               [mui/grid {:item  true :md 4 :xs 12
                                          :style {:textAlign "center"}}
                                [mui/chip {:icon  (r/as-element [inbox])
                                           :style {:backgroundColor "#ff7f7f" :margin "3px"}
                                           :label (str "Abgesagt")
                                           }]
                                [:br]
                                [mui/button {:style   {:margin "5px" :float "right"}
                                             :variant "outlined"
                                             :color   "secondary"
                                             :onClick (fn [_]
                                                        (reset! !select-event (:crowdtaskerEvent-uuid d-event))
                                                        (a/set-page :event-start :landing))
                                             } "Öffnen"]]
                               (:_accepted d-event)
                               [mui/grid {:item  true :md 4 :xs 12
                                          :style {:textAlign "center"}}
                                [mui/chip {:icon  (r/as-element [check-circle-outline])
                                           :style {:backgroundColor "#b4ff7f" :margin "3px"}
                                           :label (str "Zugesagt")
                                           }]
                                [:br]
                                [mui/button {:style   {:margin "5px" :float "right"}
                                             :variant "outlined"
                                             :color   "secondary"
                                             :onClick (fn [_]
                                                        (reset! !select-event (:crowdtaskerEvent-uuid d-event))
                                                        (a/set-page :event-briefing :landing))
                                             } "Informationen"]]

                               (pos? (count (:_missing-requirements d-event)))
                               [mui/grid {:item  true :md 4 :xs 12
                                          :style {:textAlign "left"}}
                                (for [[i missing-requirements] (map-indexed (fn [idx itm] [idx itm]) (:_missing-requirements d-event))]
                                  ^{:key (str "missing-requirements-" i)}
                                  [mui/chip {:icon  (r/as-element [filter-1])
                                             :style {:backgroundColor "#ff7f7f" :margin "3px"}
                                             :label (str "Bedingung `" missing-requirements "` nicht erfüllt!")
                                             }])
                                ]

                               (and (not (:_allowed d-event)) (:_reason d-event))
                               [mui/grid {:item  true :md 12 :xs 12
                                          :style {:textAlign "left"}}

                                [mui/chip {:icon  (r/as-element [filter-1])
                                           :style {:backgroundColor "#ff7f7f" :margin "3px"}
                                           :label (str "Bedingungen " (:_reason d-event) " nicht erfüllt!")
                                           }]
                                ]

                               (:crowdtasker d-event)
                               [mui/grid {:item  true :md 4 :xs 12
                                          :style {:textAlign "left"}}
                                [mui/chip {:icon  (r/as-element [phone-android]) ;nicht mehr nötig, sobald Fragebögen in der Webapp möglich sind...
                                           :style {:backgroundColor "#ff7f7f" :margin "3px"}
                                           :label (str "Nur in der App möglich!")
                                           }]
                                ]
                               (:_geofence d-event)
                               [mui/grid {:item  true :md 4 :xs 12
                                          :style {:textAlign "left"}}
                                [mui/chip {:icon  (r/as-element [location-off]) ;verpflichtet
                                           :style {:backgroundColor "#ff7f7f" :margin "3px"}
                                           :label (str "Bitte Ortung aktivieren!")
                                           }]
                                (if true
                                  [mui/chip {:icon  (r/as-element [location-searching]) ;optional kann auch machen wenn nicht im fence
                                             :style {:backgroundColor "#ff7f7f" :margin "3px"}
                                             :label (str "Nicht im Einsatzgebiet!")
                                             }]
                                  [mui/chip {:icon  (r/as-element [location-searching]) ;optional kann auch machen wenn nicht im fence
                                             :style {:backgroundColor "#6ee547" :margin "3px"}
                                             :label (str "Im Einsatzgebiet!")
                                             }])
                                [:br]
                                [mui/button {:style   {:margin "5px" :float "right"}
                                             :variant "outlined"
                                             :color   "secondary"
                                             :onClick (fn [_]
                                                        (reset! !select-event (:crowdtaskerEvent-uuid d-event))
                                                        (a/set-page :event-start :landing))
                                             } "Öffnen"]
                                ]

                               (empty? (:_missing-requirements d-event))
                               [mui/grid {:item  true :md 4 :xs 12
                                          :style {:textAlign "left"}}
                                (when (:_is-for-you d-event)
                                  [mui/chip {:icon  (r/as-element [notifications]) ; wenn optionale Kriterien auch erfüllt sind...
                                             :style {:backgroundColor "#6ee547" :margin "3px"}
                                             :label "Genau für mich!!"}])
                                [:br]
                                (when (:_allowed d-event)
                                  [mui/button {:style   {:margin "5px" :float "right"}
                                               :variant "outlined"
                                               :color   "secondary"
                                               :onClick (fn [_]
                                                          (reset! !select-event (:crowdtaskerEvent-uuid d-event))
                                                          (a/set-page :event-start :landing))
                                               } "Öffnen"])
                                ]

                               )
                             ])}]
     ]))


(defn get-it []
  (let [!actual-user (r/cursor store/app-state [:actual-user])
        !event-list (r/cursor store/app-state [:actual-events :list])
        !forTomId (r/cursor store/app-state [:actual-events :forTomId])
        !publisher (r/cursor store/app-state [:actual-user :publisher])
        !publisher-mode (r/cursor store/app-state [:actual-user :publisher-mode])
        show-unpublished? (and @!publisher @!publisher-mode)
        has-events? (pos? (count @!event-list))]
    (syncer/get-events !actual-user)

    [:div {:style {:backgroundColor (if has-events? "#f7d9d9" "transparent") :padding "4px"}}
     ;[:pre (pr-str @!event-list)]
     [:h2
      {:style    {:margin 0 :padding "10px 3px 0 3px" :color "#000000de" :cursor "hand"}
       :on-click #(reset! !forTomId -1)
       }
      "  Einsätze"]
     (if has-events?
       (do
         (doall
           (concat
             (for [d-event (filter :_accepted @!event-list)]
               ^{:key (str "event-card-" uuid)}
               ;[:pre (pr-str d-event)]
               [event-card d-event]
               )
             (for [d-event (filter :_rejected @!event-list)]
               ^{:key (str "event-card-" uuid)}
               ;[:pre (pr-str d-event)]
               [event-card d-event]
               ))))
       [mui/chip {:icon  (r/as-element [info])
                  :style {:backgroundColor "#ff7f7f" :margin "3px" :color "#373232"}
                  :label (str "derzeit kein Einsatz")
                  }]
       )

     [:br] [:br]
     (doall
       (for [d-event (filter #(and (or (not (false? (:crowdtaskerEvent-published %))) show-unpublished?) (not (:_rejected %)) (not (:_accepted %))) @!event-list)]
         ^{:key (str "event-card-" uuid)}
         ;[:pre (pr-str d-event)]
         [event-card d-event]
         ))

     ]
    ))